import { useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import ReCAPTCHA from "react-google-recaptcha"

import Success from './success';
import { ButtonV1 } from 'lib';

import "./index.scss"
import LoginPage from 'components/LoginPage';

const ForgotPassword = () => {
    const captchaRef = useRef(null)
    const [form, setForm] = useState({});
    const [errors, setErrors] = useState({})
    const [submit, setSubmit] = useState(false)

    const setField = (field, value) => {
        setForm({ ...form, [field]: value })

        if (!!errors[field]) {
            setErrors({ ...errors, [field]: null })
        }
    }

    const validateForm = () => {
        const { username } = form;
        const newErrors = {}

        if (!username || username === '') newErrors.username = "Enter a valid email address"

        return newErrors
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        const formErrors = validateForm()
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors)
        } else {
            const token = captchaRef.current.getValue();
            captchaRef.current.reset();
        }
        setSubmit(true)
    }

    const onCancelHandler = () => {
        // console.log("Cancelled")
    }

    return (
        <LoginPage>
            <Form className="forgotpassword_container">
                <p>Forget Password</p>
                {submit ? (<Success />) : (
                    <>
                        <Form.Group controlId='username'>
                            <Form.Label>User Name</Form.Label>
                            <Form.Control type="email" className="form-input" placeholder='Enter user name' onChange={e => setField('username', e.target.value)} value={form.username} isInvalid={!!errors.username}></Form.Control>
                            <Form.Control.Feedback type='invalid'>{errors.username}</Form.Control.Feedback>
                        </Form.Group>
                        <ReCAPTCHA sitekey='asdds' ref={captchaRef} className="g-recaptcha" />
                        <div className='form_buttons'>
                            <ButtonV1 label={"Cancel"} onClick={onCancelHandler} className="login_button cancel_button" />
                            <ButtonV1 label={"Next"} onClick={onSubmitHandler} className="login_button" />
                        </div>
                        <p className='sublabel'>You are two steps away from creating a new password. We will email you a link to reset your password.</p>
                    </>
                )}
            </Form>
        </LoginPage>

    )
}

export default ForgotPassword